var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',_vm._b({attrs:{"items":_vm.items,"value":_vm.localeValue,"label":"Language","outlined":"","loading":_vm.loading,"loader-height":"5"},on:{"change":_vm.handleChange}},'v-select',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }